module.exports = __webpack_public_path__ + "static/media/cat-map-bg.3b094671.png";